export const environment = {
	production: false,
	api_endpoint: '/api/',
	// api_endpoint: 'http://localhost:5000/',
	google_maps_api_key: 'AIzaSyAYK59CujuKV70EPagN15gWbqJo_sO7RZs',
	api: (...fragments: (string | number)[]) => environment.api_endpoint + fragments.join('/'),
	terminal_service_endpoint: 'http://localhost:4201/',
	terminal: (...fragments: string[]) => environment.terminal_service_endpoint + fragments.join('/'),
	captcha_bypass_token: 'vpos-crdv-bypass-9f2e8a1d4b6c',
	debug: (...data) => {
		console.debug(...data)
	},
	error: (...data) => {
		console_error(...data)
	},
}

const console_error = (function () {
	const ce = window.console.error
	window.console.error = environment.error
	return ce
})()
